module.exports = __webpack_public_path__ + "static/de-zeen-logo@2x-b759920329342be1173a2bec798b5521.png";